import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/moon.png'
import _imports_1 from '../assets/sun.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "switch" }

import store from '@/store';
import {onMounted, ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeSelector',
  props: {
  isInApp: Boolean,
  isInNavbar: Boolean,
},
  setup(__props) {



const isDarkMode = ref(true);

const toggleDarkMode = () => {
  updateTheme(!isDarkMode.value);
};

const updateTheme = (value: boolean) => {
  isDarkMode.value = value;
  store.dispatch('setIsDarkMode', value);
  sessionStorage.setItem('isDarkMode', value.toString());
  if (value) {
    document.body.classList.add('dark-mode');
    document.body.classList.remove('light-mode');
  } else {
    document.body.classList.add('light-mode');
    document.body.classList.remove('dark-mode');
  }
};

onMounted(() => {
  const darkMode = sessionStorage.getItem('isDarkMode');
  updateTheme(darkMode === 'false' ? false : true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["mode__button-container", [{'hide-in-app': __props.isInApp}, {'hide-in-navbar': __props.isInNavbar}]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDarkMode).value = $event)),
            onClick: toggleDarkMode
          }, null, 512), [
            [_vModelCheckbox, isDarkMode.value]
          ]),
          _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"slider round\" data-v-782b4442><div class=\"image-container\" data-v-782b4442><div class=\"moon-container\" data-v-782b4442><img src=\"" + _imports_0 + "\" alt=\"moon\" class=\"slider-image moon\" data-v-782b4442></div><div class=\"sun-container\" data-v-782b4442><img src=\"" + _imports_1 + "\" alt=\"sun\" class=\"slider-image sun\" data-v-782b4442></div></div></span>", 1))
        ])
      ])
    ], 2),
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
  ], 64))
}
}

})